export default __webpack_public_path__ + "static/media/icon-drone-failed.a0238d0f.webp";